import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f3f5092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "failed-videos" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "エラー動画送信", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "lead" }, " Desktop で変換できなかった MP4 と、各種筋肉・脂肪厚の測定結果を送信できます。 MIJL が受け取り後に確認します。 ", -1))
const _hoisted_4 = { class: "el-upload__text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", null, "クリックして選択", -1))
const _hoisted_6 = {
  key: 0,
  class: "file-cards"
}
const _hoisted_7 = { class: "file-card__name" }
const _hoisted_8 = {
  key: 0,
  class: "progress-row__error"
}
const _hoisted_9 = { class: "submit-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_card, { shadow: "never" }, {
      default: _withCtx(() => [
        _hoisted_2,
        _hoisted_3,
        _createVNode(_component_el_alert, {
          title: "1ファイルあたり 500MB まで、一度に最大 5 件、MP4 のみ送信できます。送信後の取り消しはできません。",
          type: "info",
          closable: false,
          "show-icon": "",
          class: "notice"
        }),
        _createVNode(_component_el_form, {
          "label-width": "160px",
          class: "form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "連絡事項" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.comment,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.comment) = $event)),
                  type: "textarea",
                  rows: 3,
                  maxlength: "500",
                  "show-word-limit": "",
                  placeholder: "任意。エラー内容や確認してほしい点"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "動画ファイル",
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  drag: "",
                  "auto-upload": false,
                  multiple: true,
                  limit: _ctx.maxFiles,
                  accept: "video/mp4,.mp4",
                  "on-change": _ctx.handleFileChange,
                  "on-remove": _ctx.handleFileRemove,
                  "on-exceed": _ctx.handleExceed,
                  "file-list": _ctx.fileList,
                  "onUpdate:file-list": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.fileList) = $event)),
                  disabled: _ctx.isUploading
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, [
                      _createTextVNode(" MP4 をドロップするか、"),
                      _hoisted_5,
                      _createTextVNode("（最大" + _toDisplayString(_ctx.maxFiles) + "件） ", 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["limit", "on-change", "on-remove", "on-exceed", "file-list", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        (_ctx.items.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.uid,
                  class: "file-card"
                }, [
                  _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1),
                  _createVNode(_component_el_form, {
                    "label-width": "180px",
                    class: "measure-form",
                    onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "僧帽筋厚 (cm)" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: item.trapeziusThickness,
                            "onUpdate:modelValue": ($event: any) => ((item.trapeziusThickness) = $event),
                            type: "number",
                            min: "0",
                            disabled: _ctx.isUploading
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "僧帽筋上皮下脂肪厚 (cm)" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: item.trapeziusSubcutaneousFatThickness,
                            "onUpdate:modelValue": ($event: any) => ((item.trapeziusSubcutaneousFatThickness) = $event),
                            type: "number",
                            min: "0",
                            disabled: _ctx.isUploading
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "皮下脂肪厚 (cm)" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: item.subcutaneousFatThickness,
                            "onUpdate:modelValue": ($event: any) => ((item.subcutaneousFatThickness) = $event),
                            type: "number",
                            min: "0",
                            disabled: _ctx.isUploading
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_form_item, { label: "広背筋厚 (cm)" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: item.latissimusThickness,
                            "onUpdate:modelValue": ($event: any) => ((item.latissimusThickness) = $event),
                            type: "number",
                            min: "0",
                            disabled: _ctx.isUploading
                          }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_progress, {
                    percentage: item.progress,
                    status: _ctx.progressStatus(item.status)
                  }, null, 8, ["percentage", "status"]),
                  (item.error)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(item.error), 1))
                    : _createCommentVNode("", true)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_el_button, {
            type: "primary",
            loading: _ctx.isUploading,
            disabled: !_ctx.canSubmit,
            onClick: _ctx.submit
          }, {
            default: _withCtx(() => [
              _createTextVNode(" 送信 ")
            ]),
            _: 1
          }, 8, ["loading", "disabled", "onClick"])
        ])
      ]),
      _: 1
    })
  ]))
}